import styled from 'styled-components';

export const Wrapper = styled.div`
  background: #fbfbfb;
  height: calc(100% - 142px);
  overflow-y: auto;
  padding-top: 1.25em;
  position: fixed;
  right: 0;
  top: 132px;
  width: 100vw;
  z-index: 3000;
`;
